import React from 'react';
import { gql, useMutation } from '@apollo/client';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';

const DELETE_CARDHOLDER = gql`
  mutation deleteCardholder($cardholderId: Int!) {
    deleteCardholder(cardholderId: $cardholderId)
  }
`;

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: theme.spacing(67.5),
    height: theme.spacing(30),
    [theme.breakpoints.down('sm')]: {
      top: '50%',
      width: '100%',
    },
  },
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  header: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
  },
  cardholder: {
    marginLeft: theme.spacing(4.75),
    marginRight: theme.spacing(3.5),
    marginTop: theme.spacing(-1.875),
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
    },
  },
  controls: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    justifyContent: 'center',
    marginLeft: theme.spacing(7.5),
    marginRight: theme.spacing(6),
    marginBottom: theme.spacing(1),
  },
  buttonList: {
    display: 'flex',
    justifyContent: 'space-around',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
  button: {
    marginLeft: theme.spacing(2),
    height: theme.spacing(5.25),
    width: theme.spacing(16),
  },
}));

const CardholderDelete = ({
  cardholder: { id, firstName, lastName, title, photo },
  onClose,
  onDelete,
}) => {
  const history = useHistory();
  const classes = useStyles();

  const cardholder = { id, firstName, lastName, title, photo };

  const matches = useMediaQuery('(max-width:425px)');

  const [deleteCardholder] = useMutation(DELETE_CARDHOLDER); // TODO: Handle errors
  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  const handleDelete = () => {
    deleteCardholder({ variables: { cardholderId: id } }).then(() => {
      onClose();
      onDelete();
      sleep(1000).then(() => {
        if (matches) {
          history.push('/cardholders');
        } else {
          window.history.back();
        }
      });
    });

    const devicesArray = JSON.parse(localStorage.getItem('recentSearches'));
    if (devicesArray.length) {
      const index = devicesArray.findIndex((item) => item.id === cardholder.id);
      devicesArray.splice(index, 1);
      localStorage.setItem('recentSearches', JSON.stringify(devicesArray));
    }
  };

  return (
    <Paper className={classes.paper} square>
      <div className={classes.container}>
        <h2 className={classes.header}>Are you sure you want to delete?</h2>
        <Typography className={classes.cardholder}>
          Deleting this record will permanently remove it from the system along with any associated
          credentials.
          <b style={{ color: '#f44336' }}> This action cannot be undone.</b>
        </Typography>
        <div className={classes.controls}>
          <div className={classes.buttonList}>
            <Button
              className={classes.button}
              variant="contained"
              style={{ backgroundColor: '#f44336', color: '#fff', height: '40px', width: '110px' }}
              onClick={handleDelete}
            >
              Delete
            </Button>
            <Button
              className={classes.button}
              variant="text"
              style={{ color: '#707070', height: '40px', width: '110px' }}
              onClick={onClose}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </Paper>
  );
};

export default CardholderDelete;
